/* @flow */
import styled, { css } from 'styled-components'
import THEME from './RSVP6.theme'
import {
  styleProvider,
  getBackgroundStyles,
  getTextStyleByAlignment
} from '@website/common/utils'
import WMContainer from '@website/common/components/WMContainer'
import Container from '@website/common/components/Container'

const getStyleForProp = styleProvider(THEME)

const StyledContainer = styled(Container)`
  background-color: ${getStyleForProp('blockHeading')};
  ${({ isEditing }) =>
    isEditing
      ? css`
          padding-top: 150px;
          @media only screen and (max-width: 768px) {
            padding-top: 130px;
          }
        `
      : css``};
  flex-direction: column;
  position: relative;
  overflow: hidden;
`

const WmCustomContainer = styled(WMContainer)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 2;
  margin-top: 20px;
  width: 100%;
  @media only screen and (max-width: 1024px) {
    padding: 0;
  }
  &:nth-child(1) {
    margin-top: 0px;
  }
  .control-container {
    margin-bottom: 15px;
    width: 100%;
    h1 {
      margin-bottom: 0;
    }
    p {
      padding-top: 0;
    }
  }
  .rsvp-6-container {
    width: 100%;
  }
`

const Postcard = styled.div`
  padding: 40px 0;
  box-sizing: border-box;
  background-color: ${getStyleForProp('blockHeading')};
  width: 95%;
  max-width: 1360px;
  margin: 0 auto;
  position: relative;
  @media only screen and (max-width: 768px) {
    width: 100%;
  }
  &:before {
    content: '';
    width: 90%;
    position: absolute;
    height: 76px;
    background-color: transparent;
    left: 5%;
    top: 4%;
    z-index: -1;
    border-radius: 50%;
    box-shadow: 0px -36px 26px ${getStyleForProp('border')};
    @media only screen and (max-width: 768px) {
      box-shadow: 0px -20px 26px ${getStyleForProp('border')};
    }
  }
  &:after {
    content: '';
    width: 90%;
    position: absolute;
    height: 76px;
    background-color: transparent;
    left: 5%;
    bottom: 4%;
    z-index: -1;
    border-radius: 50%;
    box-shadow: 0px 36px 26px ${getStyleForProp('border')};
    @media only screen and (max-width: 768px) {
      box-shadow: 0px 20px 26px ${getStyleForProp('border')};
    }
  }
`

const SubTitle = styled.p`
  display: block;
  width: 100%;
  color: ${getStyleForProp('subTitle')};
  margin-bottom: 20px;
  ${getTextStyleByAlignment};
  & + h1 {
    margin-top: 10px;
  }
`

const Title = styled.h1`
  color: ${getStyleForProp('heading')};
  ${getTextStyleByAlignment};
  width: 100%;
  margin-bottom: 0px;
  word-break: break-word;
`

const Paragraph = styled.p`
  color: ${getStyleForProp('paragraph')};
  width: 100%;
  ${getTextStyleByAlignment};
  line-height: 1.4;
  margin-top: 20px;
`

const Date = styled.p`
  color: ${getStyleForProp('dateText')};
  display: block;
  width: 100%;
  margin-bottom: 15px;
  ${getTextStyleByAlignment};
`

const Location = styled.a`
  display: block;
  width: 100%;
  margin-bottom: 10px;
  ${getTextStyleByAlignment};
  color: ${getStyleForProp('paragraph')};
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  @media only screen and (max-width: 768px) {
    padding-left: 40px;
    padding-right: 40px;
    box-sizing: border-box;
    @media only screen and (max-width: 457px) {
      padding-right: 20px;
      padding-left: 20px;
    }
  }
  .control-container p,
  .control-container a {
    margin-bottom: 0 !important;
    margin-top: 0 !important;
  }
`

const ImageWrap = styled.div`
  font-size: 0;
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
`

const ImageFigure = styled.div`
  text-align: center;
  font-size: 0;
  width: 70%;
  max-width: 747px;
  max-height: 270px;
  margin: 0 auto;
  border-radius: ${getStyleForProp('iconRadius')};

  .LazyLoad {
    position: relative;
    padding-top: 36.145%;
  }
  .lazy-figure {
    position: absolute;
    top: 0;
    -webkit-mask-image: -webkit-radial-gradient(white, black);
  }
  .control-container {
    margin-bottom: 0;
    margin-top: -1px;
  }
  @media only screen and (max-width: 768px) {
    width: 80%;
  }
`

const ImgTop = styled.img`
  object-fit: contain;
  object-position: bottom;
  width: 100%;
  height: 100%;
  max-height: 270px;
  position: absolute;
  top: 0;
  left: 0;
`
const ImgBottom = styled.img`
  object-fit: contain;
  object-position: top;
  width: 100%;
  height: 100%;
  max-height: 270px;
  position: absolute;
  top: 0;
  left: 0;
`

const ComponentWrapper = styled.div`
  .form-container {
    background-color: ${getStyleForProp('backgroundColor')};
    & > div {
      margin-top: -60px;
    }
    .control-container {
      width: 95%;
      max-width: 600px;
      padding: 40px 0 20px 0;
      margin: 40px auto 50px auto;
      @media only screen and (max-width: 768px) {
        max-width: 600px;
      }
      @media only screen and (max-width: 1024px) {
        margin-right: 20px;
        margin-left: 20px;
        > div {
          padding-right: 20px;
          padding-left: 20px;
        }
      }
      @media only screen and (max-width: 457px) {
        margin-right: 10px;
        margin-left: 10px;
        > div {
          padding-right: 10px;
          padding-left: 10px;
        }
      }
    }
  }
`

export default {
  StyledContainer,
  WmCustomContainer,
  Postcard,
  Date,
  Location,
  SubTitle,
  Title,
  Paragraph,
  Content,
  ImgTop,
  ImgBottom,
  ImageWrap,
  ImageFigure,
  ComponentWrapper
}
